;
(function ($) {
	$.fn.picLazyLoad = function (settings) {
		var $this = $(this),
			_winScrollTop = 0,
			_winHeight = $(window).height();
		settings = $.extend({
			threshold: 0,
			placeholder: '/images/common_course_bigblank@2x.png'
		}, settings || {});
		lazyLoadPic();
		$(window).on('scroll', function () {
			_winScrollTop = document.body.scrollTop;
			lazyLoadPic();
		});

		function lazyLoadPic() {
			$this.each(function () {
				var $self = $(this);
				if ($self.is('img')) {
					if ($self.attr('data-original')) {
						var _offsetTop = $self.offset().top;
						if ((_offsetTop - settings.threshold) <= (_winHeight + _winScrollTop)) {
							$self.attr('src', $self.attr('data-original'));
							$self.removeAttr('data-original');
						}
					}
				}
				else {
					if ($self.attr('data-original')) {
						if ($self.css('background-image') == 'none') {
							$self.css('background-image', 'url(' + settings.placeholder + ')');
						}
						var _offsetTop = $self.offset().top;
						if ((_offsetTop - settings.threshold) <= (_winHeight + _winScrollTop)) {
							$self.css('background-image', 'url(' + $self.attr('data-original') + ')');
							$self.removeAttr('data-original');
						}
					}
				}
			});
		}
	}
})(Zepto);


//////////////////
// WEBPACK FOOTER
// ./js/lazyload.js
// module id = 1
// module chunks = 0